import React, { FC } from "react"
import { Grid } from "@mui/material"
import {
  UnstableSensorsChart,
  UnstableSensorsTable,
} from "src/components"

export const UnstableSensorsContent: FC = () => {
  return (
    <Grid container direction="column" spacing={4} wrap="nowrap">
      <Grid item minWidth={0}>
        <UnstableSensorsChart />
      </Grid>
      <Grid item minWidth={0}>
        <UnstableSensorsTable />
      </Grid>
    </Grid>
  )
}
